export default [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "poker" */ './views/Home.vue'),
    },
    {
        path: '/:id',
        name: 'Games',
        component: () => import(/* webpackChunkName: "poker" */ './views/Game.vue'),
    },
]
